const SET_CONFIG_NAME = 'SET_CONFIG_NAME';

export default {
  SET_CONFIG_NAME
};
